import { render, staticRenderFns } from "./plastics.vue?vue&type=template&id=e85f2ef6&scoped=true&"
import script from "./plastics.vue?vue&type=script&lang=js&"
export * from "./plastics.vue?vue&type=script&lang=js&"
import style0 from "./plastics.vue?vue&type=style&index=0&id=e85f2ef6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85f2ef6",
  null
  
)

export default component.exports